"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../../atoms/Button"));

var _style = require("./style");

var BobInfo = function BobInfo(_ref) {
  var title = _ref.title,
      body = _ref.body,
      button = _ref.button;
  return _react["default"].createElement(_style.Container, null, _react["default"].createElement(_style.Title, null, title), _react["default"].createElement(_style.Body, null, body), _react["default"].createElement(_style.ButtonContainer, null, _react["default"].createElement(_Button["default"], button)));
};

BobInfo.propTypes = {
  title: _propTypes["default"].string.isRequired,
  body: _propTypes["default"].elementType.isRequired,
  button: _propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    handleClick: _propTypes["default"].func.isRequired
  }).isRequired
};
BobInfo.defaultProps = {};
var _default = BobInfo;
exports["default"] = _default;